import { Checkbox, Form, Tooltip, Input } from "antd";
import SpeechToTextButton from "./SpeechToText";
const { TextArea } = Input;

const Template3 = ({
  question,
  type_left,
  value,
  onChange,
  formName,
  tempData,
  isDisable,
  tooltipValue,
  placeholder,
  section_res,
  onCheckboxChange,
  isChecked,
  isSummary,
  DisableCheckbox,
  activeMicIndex,
  setActiveMicIndex,
  loginType,
  form
}) => {
  let current_section = sessionStorage.getItem('section_id');
  const rowValue = type_left === "TA" ? 8 : 1;

  const style =
    tempData?.type_right === "Pair"
      ? "py-2 inline-block w-1/2 pr-2 align-top checkbox-start labelInput"
      : "py-2 labelInput";
  // Insert speech text into textarea
  const handleSpeechInsert = (speechText) => {
    const currentValue = form.getFieldValue(formName) ?? "";
    const updated = `${currentValue} ${speechText}`.trim();
    form.setFieldsValue({
      [formName]: updated,
    });
    onChange(updated, tempData, "text", isSummary);
  };
  return (
    <div className={style}>
      <Tooltip title={tooltipValue} placement="bottom" trigger={["focus"]}>
        <Form.Item
          className="mb-0"
          label={
            question ? (
              <div className="flex flex-col">
                {section_res && loginType !== "0" && current_section !== "8" ? (
                  <Checkbox
                    defaultChecked={isChecked}
                    onChange={(e) => onCheckboxChange(e, tempData)}
                    disabled={DisableCheckbox}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: question }}
                      className="text-start whitespace-normal self-end mb-2"
                    />
                  </Checkbox>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{ __html: question }}
                    className="text-start whitespace-normal self-end mb-2"
                  />
                )}
              </div>
            ) : null
          }
        >
          {/* MIC + TEXTAREA */}
          <div className="flex flex-col sm:flex-row sm:items-start gap-2">
            <div className="flex-shrink-0">
              <SpeechToTextButton
                index={tempData?.item_id}
                isActive={activeMicIndex === tempData?.item_id}
                disabled={isDisable}
                onSpeech={handleSpeechInsert}
                onStart={() => setActiveMicIndex(tempData?.item_id)}
                onStop={() => setActiveMicIndex(null)}
              />
            </div>
            <Form.Item
              name={formName}
              noStyle
            >
              <TextArea
                onChange={(e) => onChange(e.target.value, tempData, "text", isSummary)}
                className={`w-full ${isDisable ? "bg-gray-200" : ""}`}
                autoSize={type_left !== "TA"}
                rows={rowValue}
                readOnly={isDisable}
                status={tempData?.is_edited === 1 ? "error" : null}
                placeholder={placeholder}
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Tooltip>
    </div>
  );
};

export default Template3;